import { render, staticRenderFns } from "./BranchTransfers.vue?vue&type=template&id=0c9cd058&scoped=true"
import script from "./BranchTransfers.vue?vue&type=script&lang=js"
export * from "./BranchTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9cd058",
  null
  
)

export default component.exports